import generateGetAutomationErrorLogsApiPayload from './generateGetAutomationErrorLogsApiPayload';

/** --- This function handling pagination for auatomation-error-log lists --- **/
const handlePagination = (params) => {
  const {
    paginationData = {},
    filterValues = {},
    type = '',
    getAutomationErrorLogs,
    setPaginationData,
    page_limit,
    selectedSk,
    last_updated_format,
  } = params || {};

  const { pageLimit = 10, apiNextToken = '', apiTransitionToken = '', isForward = true } = paginationData || {};

  /** --- Defining and initializing pagination variable with default values --- **/
  let pagination = {
    pageLimit,
    token: '',
    direction: 'forward',
    isForward: true,
  };

  if (type === 'next') {
    /** --- This code is executed on onNextPageClick --- **/
    pagination = {
      ...pagination,
      token: !isForward ? apiTransitionToken : apiNextToken,
      direction: 'forward',
      isForward: true,
    };
  } else if (type === 'prev') {
    /** --- This code is executed on onPrevPageClick --- **/

    pagination = {
      ...pagination,
      token: isForward ? apiTransitionToken : apiNextToken,
      direction: 'reverse',
      isForward: false,
    };
  } else {
    /** --- This code is executed on onPageChange --- **/

    setPaginationData({
      ...paginationData,
      pageLimit: page_limit,
    });
    pagination = {
      ...pagination,
      pageLimit: page_limit,
    };
  }

  /** --- This function fetching automation-error-log lists with selected filter-values and pagination-values ---**/
  getAutomationErrorLogs(selectedSk, generateGetAutomationErrorLogsApiPayload(filterValues, last_updated_format), pagination);
};

export default handlePagination;
